<script setup>
import { onBeforeMount, onMounted, ref, watch, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import { signOut } from 'aws-amplify/auth';
import opmStore from '@/lib/storeOwnerProjectManager';
import BreadcrumbsV3 from '@/components/interface/AppBreadcrumbsV3.vue';
const route = useRoute();
const router = useRouter();

const primaryNav = ref([]);
const environment = process.env.ENVIRONMENT

async function logOut(){
    await signOut();
    router.push({ path: '/' });
    opmStore.dispatch('deleteState');
}
onBeforeMount(async() => {
    await opmStore.dispatch('getUserChrome');
    primaryNav.value = opmStore.state.chrome.primaryNav;
})
onMounted(async() => {
    opmStore.dispatch('clearErrors');
    console.log('OwnerProjectManager mounted')
})
function nav(path) {
    if (path.startsWith('http://') || path.startsWith('https://')) {
        window.open(path, '_blank');
    } else if (route.path !== path) {
        router.push({ path: path });
    }
}
watch(route, async (to) => {
    if(to.fullPath === '/'){
        const primaryNav = this.$store.getters.getprimaryNav;
        if(primaryNav?.[0]?.url){
            var props = { path: primaryNav[0].url};
            this.$router.push(props);
        }
    }
    opmStore.dispatch('clearErrors');
})

const showPageLoading = computed(() => {
    const showLoadingChecks = [
        opmStore.state.isPageDataLoading,
        route.name !== 'notFound'
    ];
    if(showLoadingChecks.every(value => value === true)) {
        return true;
    }
    return false;
})
const errorAlerts = computed(() => {
    return opmStore.state.errors;
});
watch(errorAlerts, (newVal) => {
    if(newVal.length > 0){
        document.querySelector('main')?.scrollTo({ top: 0, behavior: 'smooth' });
    }
}, { deep: true });
</script>

<template>
    <v-app id='inspire'>
        <v-layout>
        <v-navigation-drawer
            color='primary'
            width='256'
            :style='{ borderWidth: "0" }'
            permanent
        >
            <v-col style='height: 64px'>
                <img
                    :src='require("@/assets/JAMB-logo-white.svg")'
                    height='40px'
                />
            </v-col>
            <template v-if="environment !== 'prod'">
                <v-col><h3>{{ environment }}</h3></v-col>
            </template>
            <v-list-item
                v-for='item in primaryNav'
                :key='item.url'
                :title='item.title'
                @click='nav(item.url)'
            ></v-list-item>
        </v-navigation-drawer>

        <v-app-bar color='primary' elevation='0'>
            <BreadcrumbsV3></BreadcrumbsV3>
            <template v-slot:append>
                <v-menu>
                    <template v-slot:activator='{ props }'>
                        <v-btn icon v-bind='props'>
                            <v-icon>mdi-account-circle</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item @click='logOut'>
                            <v-list-item-title><v-icon icon='mdi-logout'></v-icon> Signout</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </v-app-bar>

        <v-main>
            <v-container fluid>
                <template v-for="error in errorAlerts" :key="error">
                    <v-alert :text='error' type='error' variant='tonal' class="mb-4">
                        <template v-slot:text><p v-html="error"></p></template>
                    </v-alert>
                </template>
                <v-row v-if='showPageLoading'>
                    <v-col align='center'>
                        <v-progress-circular color='primary' indeterminate></v-progress-circular>
                    </v-col>
                </v-row>
                <RouterView :key="route.fullPath"></RouterView>
            </v-container>
        </v-main>
            <v-overlay
                :model-value="opmStore.state.calculating"
                :persistent="true"
                class="align-center justify-center"
            >
                <v-progress-circular
                    color="primary"
                    size="64"
                    indeterminate
                ></v-progress-circular>
            </v-overlay>
        </v-layout>
    </v-app>
</template>

<style>
main {
    overflow: scroll;
    background-color: #f2f5f7;
}
.v-container > .v-container {
    background-color: white;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.bottom .v-list-item-title {
    font-size: 12px;
}
* {
    box-sizing: border-box;
    font-family: Verdana, sans-serif;
}
html,
body {
    height: 100%;
    margin: 0;
    padding: 0;
    width: 100%;
}
#app {
    width: 100%;
    height: 100%;
}
.v-input__details {
    padding-left: 0 !important;
}
</style>
